import React from 'react'
import PaidRoundedIcon from '@mui/icons-material/PaidRounded'
import {IconButton} from '@mui/material'
import {consultation as textsConsultation} from '../../../translate/Translate.jsx'

import './consultationBuyButton.scss'
import {getLocal} from '../../../hooks/useStorage/useStorage.jsx'

const ConsultationBuyButton = ({data, onClick}) => {
    const pix = getLocal('pix')
    const onlinePayments = getLocal('onlinePayments')
    if (!pix && !onlinePayments) return <div/>
    if ((data?.total || 0) === 0) return <div/>
    return <div className={'container-add-button'}>
        <div className={'div-add-button'}>
            <div className={'left'}>
                <label className={'label-price'} id={'add-item'}>
                    {(data?.total || 0).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}
                </label>
            </div>
            <div className={'right'}>
                <div className={'button'} onClick={() => onClick()}>
                    <label className={'label-add'}>
                        {textsConsultation.pay}
                    </label>
                    <IconButton>
                        <PaidRoundedIcon className={'icon'}/>
                    </IconButton>
                </div>
            </div>
        </div>
    </div>
}

export default ConsultationBuyButton
